import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../app/guards'
import { BooksHealthPage } from '../../features/accounting/books-health-page'
import { booksHealthSearchSchema } from '../../features/accounting/books-health-search'
import { AskAssistantButton, ReviewWithAssistantButton } from '../../features/ai/books-entry'

/**
 * Books health, with "Ask the assistant" and, when the month has open findings, "Review with the assistant"
 * through the page's `reviewAction` prop.
 */
export const Route = createFileRoute('/_app/books-health')({
  staticData: { crumb: 'booksHealth' },
  validateSearch: booksHealthSearchSchema,
  beforeLoad: ({ context }) => requireAnyPermission(context.session, 'ledger.read', 'reports.financial'),
  component: () => (
    <BooksHealthPage
      reviewAction={({ from, to, health }) => (
        <>
          <AskAssistantButton />
          <ReviewWithAssistantButton from={from} to={to} health={health} />
        </>
      )}
    />
  ),
})
